import { useCallback, useEffect, useState } from 'react'
import { message } from 'antd'
import { RelationEntity, relationsEntityType } from '../../interfaces'
import fetchAPI from '../../../../../lib/utils/fetch-api'

interface UseEntityRelationsProps {
  entityType: relationsEntityType
  entityId: number | string
  enabled?: boolean
}

interface UseEntityRelationsReturn {
  relations: RelationEntity[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export const useEntityRelations = ({
  entityType,
  entityId,
  enabled = true,
}: UseEntityRelationsProps): UseEntityRelationsReturn => {
  const [relations, setRelations] = useState<RelationEntity[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchRelations = useCallback(async () => {
    if (!enabled || !entityId || entityId === 'new') return

    setLoading(true)
    setError(null)

    try {
      const response = await fetchAPI(`/api/relations/${entityType}/${entityId}`)
      if (response.data) {
        setRelations(response.data)
      }
    } catch (err) {
      console.error('Error fetching relations:', err)
      const errorMessage = 'Ошибка загрузки связанных сущностей'
      setError(errorMessage)
      message.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }, [entityType, entityId, enabled])

  useEffect(() => {
    fetchRelations()
  }, [fetchRelations])

  return {
    relations,
    loading,
    error,
    refetch: fetchRelations,
  }
}
